import React, { Suspense, useContext, useEffect } from "react";
import { Switch, Redirect } from "react-router-dom";
import { AuthPagesPath, MainPagesPath } from "./Paths";
import { Route } from "react-router-dom";
import Overlay from "../components/Overlay";
import Schemes from "../pages/Schemes";
import CustomerSchemes from "../pages/CustomerSchemes";
import Header from "../components/Header";
import UploadSchemes from "../pages/UploadSchemes";
import ViewScheme from "../pages/ViewScheme";
import DrawerLayout from "../layout/DrawerLayout";
import UploadPromotion from "../pages/UploadPromotion";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorize } from "../actions/app-action-types";
import { toast } from "react-toastify";
import { AuthContext } from "../utilities/authContext";
import EditorsManagement from "../pages/Admin/EditorsManagement";
import PageNotFound from "../components/PageNotFound";
import MachineModels from "../pages/Machine/Models";
import ModelDetails from "../pages/Machine/ModelDetails";
import AllPromotions from "../pages/AllPromotions";

const PrivateRouter = (props) => {
  const dispatch = useDispatch();
  const isUnauthorize = useSelector((state) => state.app.isUnauthorize);
  const permissions = useSelector((state) => state.user.permissions);
  const { logout } = useContext(AuthContext);

  const isAdmin =
    permissions?.appIDs?.includes("3") && permissions?.moduleIDs?.includes("0");

  useEffect(() => {
    if (isUnauthorize) {
      dispatch(setAuthorize());
      localStorage.removeItem("token");
      localStorage.removeItem("LastTokenRefresh");
      localStorage.removeItem("LastLogin");
      localStorage.removeItem("userData");
      logout();
      toast.error("session has expired", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnauthorize]);

  return (
    <>
      <Header />
      <DrawerLayout>
        <Suspense fallback={<Overlay />}>
          <Switch>
            <Redirect exact from="/" to={MainPagesPath.schemes} />
            <Redirect
              exact
              from={AuthPagesPath.login}
              to={MainPagesPath.allPromotions}
            />
            <Route
              path={MainPagesPath.schemes}
              component={isAdmin ? Schemes : PageNotFound}
            />
            <Route
              exact
              path={
                MainPagesPath.userSchemes + "/:customerCode/:token/:langId?"
              }
              component={CustomerSchemes}
            />
            <Route
              path={MainPagesPath.uploadScheme}
              component={isAdmin ? UploadSchemes : PageNotFound}
            />
            <Route
              exact
              path={MainPagesPath.updateScheme + "/:schemeId"}
              component={(prop) => <UploadSchemes isUpdate={true} {...prop} />}
            />
            <Route
              exact
              path={MainPagesPath.scheme + "/:schemeId"}
              component={ViewScheme}
            />
            <Route
              exact
              path={MainPagesPath.allPromotions}
              component={AllPromotions}
            />
            <Route
              exact
              path={MainPagesPath.uploadPromotion}
              component={UploadPromotion}
            />
            <Route
              exact
              path={MainPagesPath.editPromotion + "/:schemeId"}
              component={(prop) => (
                <UploadPromotion isEditMode={true} {...prop} />
              )}
            />
            <Route
              exact
              path={MainPagesPath.allEditors}
              component={isAdmin ? EditorsManagement : PageNotFound}
            />
            <Route
              exact
              path={MainPagesPath.machineModels}
              component={MachineModels}
            />
            <Route
              exact
              path={MainPagesPath.modelDetails + "/:modelName"}
              component={ModelDetails}
            />
            <Route path="*" render={() => <Redirect to="/" />} />
            {props.children}
          </Switch>
        </Suspense>
      </DrawerLayout>
    </>
  );
};

export default PrivateRouter;
